import { PropsWithChildren } from 'react';
import { AnalyticsEvent } from '../../web-analytics/AnalyticsEvent';
import { analyticsTrack } from '../../web-analytics/webAnalytics';

export const NewTabLink = (
  props: PropsWithChildren<{
    href: string | null;
    analyticsEvent?: AnalyticsEvent;
    analyticsProperties?: object;
  }>
) => {
  const { href, analyticsEvent, analyticsProperties, children } = props;
  return href ? (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      onClick={() => {
        if (analyticsEvent) analyticsTrack(analyticsEvent, analyticsProperties);
      }}
    >
      {children}
    </a>
  ) : (
    <span>{children}</span>
  );
};
